import { render, staticRenderFns } from "./AccountUsageFrequency.vue?vue&type=template&id=e0201d22&scoped=true"
import script from "./AccountUsageFrequency.vue?vue&type=script&lang=js"
export * from "./AccountUsageFrequency.vue?vue&type=script&lang=js"
import style0 from "./AccountUsageFrequency.vue?vue&type=style&index=0&id=e0201d22&prod&scoped=true&lang=css"
import style1 from "./AccountUsageFrequency.vue?vue&type=style&index=1&id=e0201d22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0201d22",
  null
  
)

export default component.exports